import { mapActions } from 'vuex';
import { UNAVAILABLE_AVAILABILITY_STATUSES } from 'Store/constants/availability';

const AddToCartState = Object.freeze({
  Initial: 'initial',
  Loading: 'loading',
  Success: 'success',
});

const TIMEOUT_DURATION = 3000;

export default {
  data() {
    return {
      AddToCartState,
      addToCartState: AddToCartState.Initial,
      selectedQuantity: 1,
      productIsReplaced: false,
    };
  },
  mounted() {
    if (this.product && typeof this.product.quantityAmount === 'number') {
      this.selectedQuantity = this.product.quantityAmount;
    }
  },
  methods: {
    ...mapActions('miniCart', ['addToCart']),
    getAddToCartButtonProps({ add, added } = {}) {
      if (this.addToCartState === this.AddToCartState.Success) {
        return {
          class: 'button--japaneseLaurel',
          title: added,
          icon: 'added_to_cart_check',
          disabled: true,
        };
      }

      return {
        icon: 'cart',
        title: add,
      };
    },
    async handleAddToCart(
      quantity,
      skipAlternativeProductsCheck = false,
      productToAdd = null
    ) {
      if (!productToAdd) {
        productToAdd = this.product;
      }

      this.addToCartState = this.AddToCartState.Loading;

      const productPriceEqualsZero =
        !!productToAdd?.prices && Number(productToAdd.prices.price) === 0;

      if (
        !skipAlternativeProductsCheck &&
        typeof productToAdd?.availability === 'string' &&
        productToAdd.availability.toUpperCase() !== 'INSTANT' &&
        !!productToAdd?.hasCrossReferences
      ) {
        const altDialog = this.$refs?.alternativeProductsDialog;

        const alternativeProduct = await Promise.race([
          altDialog?.fetchAlternativeProduct?.(
            productToAdd.productId,
            this.selectedQuantity
          ),
          new Promise((resolve) => setTimeout(() => resolve(null), TIMEOUT_DURATION)),
        ]);

        if (alternativeProduct) {
          altDialog?.showDialog?.(alternativeProduct);
          this.addToCartState = this.AddToCartState.Initial;
          return;
        }
      }

      if (
        productPriceEqualsZero ||
        (typeof productToAdd?.availability === 'string' &&
          UNAVAILABLE_AVAILABILITY_STATUSES.includes(
            productToAdd.availability.toUpperCase()
          ))
      ) {
        if (!skipAlternativeProductsCheck) {
          this.$refs?.unavailableProductDialog?.show?.();
        }
        this.addToCartState = this.AddToCartState.Initial;
        return;
      }

      try {
        await this.addToCart({
          product: productToAdd,
          quantity: this.selectedQuantity,
        });
        this.addToCartState = this.AddToCartState.Success;
      } finally {
        setTimeout(() => {
          this.addToCartState = this.AddToCartState.Initial;
          this.productIsReplaced = false;
        }, 2000);
      }
    },
    handleAlternativeProductConfirm(alternativeProduct) {
      this.productIsReplaced = true;
      this.handleAddToCart(this.selectedQuantity, true, alternativeProduct);
    },
    handleAlternativeProductCancel() {
      if (this.productIsReplaced) {
        return;
      }
      this.handleAddToCart(this.selectedQuantity, true);
    },
    handleQuantityChange(payload) {
      const quantity =
        payload && typeof payload === 'object' && 'quantity' in payload
          ? payload.quantity
          : payload;
      this.selectedQuantity = quantity;
    },
  },
};
